import React from 'react';
import { Icon as ReactIcon } from '@a-ui/react';
import Typography from '../Typography';
import { useTabEvents } from './hooks';

export interface AccordionTabProps {
  id: string;
  title: string;
  expanded?: boolean;
  parent?: HTMLDivElement | null;
}

const AccordionTab: React.FC<AccordionTabProps> = ({ id, title, children, parent }) => {
  const { handleClick, handleKeyPress } = useTabEvents(parent!);

  return (
    <>
      <Typography variant="h2" classNames="m-accordion__tab__wrapper">
        <button
          id={`${id}-title`}
          type="button"
          className="m-accordion__tab"
          onClick={handleClick}
          aria-expanded="false"
          aria-controls={id}
          onKeyDown={handleKeyPress}
        >
          {title}
          <ReactIcon className="m-accordion__tab__icon" name="ai-arrow-down-1" />
        </button>
      </Typography>

      <div
        role="region"
        id={id}
        className="m-accordion__tab__content"
        aria-labelledby={`${id}-title`}
        hidden
      >
        <div className="m-accordion__tab__content__inner">{children}</div>
      </div>
    </>
  );
};

export default AccordionTab;
